export class APIRequestError extends Error {
  response?: Response;
  cause?: Error;
  url?: string;

  constructor(
    message: string,
    options?: {
      response?: Response;
      cause?: Error;
      url: string;
    },
  ) {
    super(message.trim());
    this.name = 'APIRequestError';

    if (options?.response) {
      this.response = options.response;
    }
    if (options?.cause) {
      this.cause = options.cause;
    }

    if (options?.url) {
      this.url = options.url;
    }
  }

  toJSON() {
    return Object.getOwnPropertyNames(this)
      .filter((p) => p !== 'stack')
      .reduce(
        (acc, key) => ({
          ...acc,
          [key]: this[key as keyof this],
        }),
        {},
      );
  }

  toString() {
    return [this.name, this.url, this.response?.status, this.message].filter(Boolean).join(' ').trim();
  }
}
